import { render, staticRenderFns } from "./super-menu.vue?vue&type=template&id=776d9db5&scoped=true&"
import script from "./super-menu.vue?vue&type=script&lang=js&"
export * from "./super-menu.vue?vue&type=script&lang=js&"
import style0 from "./super-menu.vue?vue&type=style&index=0&id=776d9db5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776d9db5",
  null
  
)

export default component.exports